var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useStore } from "effector-react";
import { Box, Collapse, IconButton, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Close, FastForward, FastRewind, Pause, PlayArrow, } from "@material-ui/icons";
import { If } from "frontend/src/ui/if";
import { PlayerContainer } from "./player-container";
import { PlayerTimeRange } from "./timerange";
import { Volume } from "frontend/src/features/change-audio-volume";
import { $playerCurrentTrack, $playerHasCurrentTrack, $playerHasNextTrack, $playerHasPreviousTrack, } from "../../../domain/player-track-queue";
import { tryPlayNextTrackInQueue } from "../../play-track-from-queue";
import { $isAudioPlaying } from "../../../domain/audio";
import { pause, resume } from "../../control-audio";
var useStyles = makeStyles({
    container: {
        "& .MuiCollapse-container": {
            width: "100%",
        },
    },
    box: {
        transition: "height 0.2s",
    },
});
var Bar = function (_a) {
    var track = _a.track, hasCurrentTrack = _a.hasCurrentTrack, isPlaying = _a.isPlaying, playPause = _a.playPause, hasNextTrack = _a.hasNextTrack, playNextTrack = _a.playNextTrack;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "body1", noWrap: true }, track === null || track === void 0 ? void 0 : track.title),
        React.createElement(Box, { display: "flex", ml: "auto" },
            React.createElement(Box, null,
                React.createElement(IconButton, { onClick: playPause, disabled: !hasCurrentTrack }, isPlaying ? (React.createElement(Pause, { fontSize: "large" })) : (React.createElement(PlayArrow, { fontSize: "large" })))),
            React.createElement(IconButton, { disabled: !hasNextTrack, onClick: playNextTrack },
                React.createElement(FastForward, { fontSize: "large" })))));
};
var FullBar = function (_a) {
    var track = _a.track, hasCurrentTrack = _a.hasCurrentTrack, isPlaying = _a.isPlaying, playPause = _a.playPause, hasNextTrack = _a.hasNextTrack, playNextTrack = _a.playNextTrack;
    var hasPreviousTrack = useStore($playerHasPreviousTrack);
    var playPreviousTrack = function (evt) {
        evt.stopPropagation();
        tryPlayNextTrackInQueue();
    };
    return (React.createElement(Box, { mt: "auto" },
        React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" },
            React.createElement(Typography, { variant: "h5" }, track === null || track === void 0 ? void 0 : track.title),
            React.createElement(Typography, null, track && track.type === "public" && track.artist)),
        React.createElement(Box, null,
            React.createElement(PlayerTimeRange, { track: track })),
        React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(IconButton, { disabled: !hasPreviousTrack, onClick: playPreviousTrack },
                React.createElement(FastRewind, { fontSize: "large" })),
            React.createElement(Box, null,
                React.createElement(IconButton, { disabled: !hasCurrentTrack, onClick: playPause }, isPlaying ? (React.createElement(Pause, { fontSize: "large" })) : (React.createElement(PlayArrow, { fontSize: "large" })))),
            React.createElement(IconButton, { disabled: !hasNextTrack, onClick: playNextTrack },
                React.createElement(FastForward, { fontSize: "large" }))),
        React.createElement(Box, { mb: 2 },
            React.createElement(Volume, null))));
};
export var MobilePlayerBar = function () {
    var classes = useStyles();
    var track = useStore($playerCurrentTrack);
    var isPlaying = useStore($isAudioPlaying);
    var hasCurrentTrack = useStore($playerHasCurrentTrack);
    var hasNextTrack = useStore($playerHasNextTrack);
    var _a = __read(React.useState(false), 2), showFullMenu = _a[0], setShowFullMenu = _a[1];
    var playPause = function (evt) {
        evt.stopPropagation();
        isPlaying ? pause() : resume();
    };
    var playNextTrack = function (evt) {
        evt.stopPropagation();
        tryPlayNextTrackInQueue();
    };
    return (React.createElement(PlayerContainer, { onClick: function () {
            if (!showFullMenu) {
                setShowFullMenu(true);
            }
        }, className: classes.container },
        React.createElement(Collapse, { in: showFullMenu, collapsedHeight: 60 },
            React.createElement(Box, { display: "flex", flexDirection: "column", width: "100%", height: 300 },
                React.createElement(If, { condition: showFullMenu },
                    React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
                        React.createElement(IconButton, { onClick: function () { return setShowFullMenu(false); } },
                            React.createElement(Close, null)))),
                React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" },
                    React.createElement(If, { condition: !showFullMenu },
                        React.createElement(Bar, { track: track, hasCurrentTrack: hasCurrentTrack, hasNextTrack: hasNextTrack, playPause: playPause, isPlaying: isPlaying, playNextTrack: playNextTrack }))),
                React.createElement(If, { condition: showFullMenu },
                    React.createElement(FullBar, { track: track, hasCurrentTrack: hasCurrentTrack, hasNextTrack: hasNextTrack, playPause: playPause, isPlaying: isPlaying, playNextTrack: playNextTrack }))))));
};
